// extracted by mini-css-extract-plugin
export default {"container":"style_container__ilgel","autocompleteContainer":"style_autocompleteContainer__6sfTw"};